/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Fragment from 'ember-data-model-fragments/fragment';

export default class SearchPageOptions extends Fragment {}
